export const buttonClass = (isDisabled) => {
  // CSS styles are based on the class, not the disabled attribute
  return `btn${isDisabled ? ' btn--disabled' : ''}`;
};
